import {StyleSheet} from 'react-native';

export const PIE_CHART_HEIGHT = 350;
export const PIE_CHART_INNER_RADIUS = 90;
export const PIE_CHART_MARGIN = 50;

export const styles = StyleSheet.create({
  pieChartContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    marginVertical: -PIE_CHART_MARGIN * 0.5,
    // @ts-ignore
    outline: 'none',
    WebkitTapHighlightColor: 'transparent',
    userSelect: 'none',
  },
  base: {
    width: PIE_CHART_HEIGHT,
    height: PIE_CHART_HEIGHT,
    alignSelf: 'center',
    alignItems: 'center',
  },
  pieChartInner: {
    position: 'absolute',
    left: '50%',
    marginLeft: -PIE_CHART_INNER_RADIUS,
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: PIE_CHART_INNER_RADIUS * 2,
  },
  centeredText: {
    textAlign: 'center',
    fontSize: 14,
    marginLeft: 4,
  },
  percentContainer: {
    alignItems: 'center',
  },
  pieChartLabels: {
    display: 'none',
  },
});
